import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Box } from '@material-ui/core';
import Routes from 'routes';
import { ReactComponent as UpgradeIcon } from 'assets/icons/others/upgrade.svg';
import defaultLocales from 'globals/locales/default';
import { useBillingType } from 'globals/hooks/useBillingType';
import { UserBillingType } from 'globals/types';
import FsBodySmallBold from 'ui-elements/typography/FsBodySmallBold';
import FsButton from 'ui-elements/buttons/FsButton';
import UpgradeModal from '../SidePanelModals/UpgradeModal';
import { Paragraph, WrapperBox } from './UpgradeBox.style-elements';

const UpgradeBox: React.FC = () => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const isBillingTypeStandard = useBillingType(UserBillingType.STANDARD);
  const isBillingTypeEnterprise = useBillingType(UserBillingType.ENTERPRISE);

  return (
    <>
      <WrapperBox>
        <Box marginBottom={2}>
          <UpgradeIcon />
        </Box>
        <Box marginBottom={2}>
          <Paragraph>
            {defaultLocales.upgradeSidebarInfo[0]}{' '}
            <FsBodySmallBold component="span" color="textPrimary">
              {defaultLocales.upgradeSidebarInfo[1]}
            </FsBodySmallBold>{' '}
            {defaultLocales.upgradeSidebarInfo[2]}
          </Paragraph>
        </Box>
        <Box>
          {isBillingTypeStandard && (
            <FsButton
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => setShowModal(true)}
            >
              {defaultLocales.upgrade}
            </FsButton>
          )}
          {isBillingTypeEnterprise && (
            <FsButton
              component={Link}
              to={Routes.UPGRADE}
              variant="contained"
              color="primary"
              fullWidth
            >
              {defaultLocales.upgrade}
            </FsButton>
          )}
        </Box>
      </WrapperBox>
      <UpgradeModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </>
  );
};

export default UpgradeBox;
